import { render, staticRenderFns } from "./custom-input-number.vue?vue&type=template&id=34cb74d8"
import script from "./custom-input-number.vue?vue&type=script&lang=js"
export * from "./custom-input-number.vue?vue&type=script&lang=js"
import style0 from "./custom-input-number.vue?vue&type=style&index=0&id=34cb74d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports